var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app--mounted",attrs:{"id":"app"}},[(_vm.loading)?[_c('div',{staticClass:"app__load-wrapper"},[_c('spinner')],1)]:[_c('router-view')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }